import type { Announcement } from '../types';

export function announcementAudienceLabel(announcement: Pick<Announcement, 'deliveryMode' | 'targetType' | 'targetId' | 'targetName'>): string {
  if (announcement.deliveryMode === 'test') return 'Test delivery · author only';
  if (announcement.deliveryMode !== 'audience') return 'Delivery audience unverified (legacy record)';
  if (announcement.targetType === 'all') return 'All eligible students in the sender’s scope';
  if (announcement.targetType === 'unknown') return 'Audience delivery · audience details unavailable';
  return `${announcement.targetType}: ${announcement.targetName || announcement.targetId || 'Selected audience'}`;
}
